import { Link as LinkComponent } from 'src/components';
import styled, { css } from 'styled-components';
import { LogoLink as LogoLinkComponent } from '../LogoLink';

const HUBSPOT_BREAKPOINT = '768px';
const HUBSPOT_MAX_WIDTH = '870px';

export const FooterLink = styled(LinkComponent)(
  ({ theme }) => css`
    outline: none;
    text-decoration: none;
    transition: all 0.5s ease;

    &:hover {
      color: ${theme.co.primary20};
    }
  `,
);

const List = styled.ul(
  () => css`
    margin: unset;
    padding: unset;
    list-style: none;
    max-width: unset;
  `,
);

const ListItem = styled.li(
  () => css`
    max-width: unset;
  `,
);

export const Footer = styled.footer(
  ({ theme }) => css`
    padding: ${theme.sz.s16} ${theme.sz.s6};
    background-color: ${theme.co.secondary20};
    color: ${theme.co.neutral99};
  `,
);

export const InternalLinksContainer = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s8};
    display: grid;
    grid-template-columns: repeat(1fr);

    @media (min-width: ${HUBSPOT_BREAKPOINT}) {
      max-width: ${HUBSPOT_MAX_WIDTH};
      margin-top: ${theme.sz.s16};
      margin-left: auto;
      margin-right: auto;
      grid-column-gap: ${theme.sz.s3};
      grid-template-columns: repeat(4, 1fr);
    }
  `,
);

export const InternalLink = styled(FooterLink)(
  ({ theme }) => css`
    min-height: ${theme.sz.s7};
    display: flex;
    align-items: center;
    color: inherit;
    ${theme.typography.paragraph.base};
  `,
);

export const InternalLinksList = styled(List)(() => css``);

export const InternalLinksListItem = styled(ListItem)(
  ({ theme }) => css`
    @media (max-width: calc(${HUBSPOT_BREAKPOINT} - 1px)) {
      padding-top: ${theme.sz.s2};
      padding-bottom: ${theme.sz.s2};
      border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary90};
    }
  `,
);

export const LinksListItem = styled(ListItem)(() => css``);

export const LogoLink = styled(LogoLinkComponent)(
  () => css`
    margin-left: auto;
    margin-right: auto;
  `,
);

export const ScenariosLinkButtonContainer = styled.div(
  ({ theme }) => css`
    width: fit-content;
    margin-top: ${theme.sz.s8};
    margin-left: auto;
    margin-right: auto;
  `,
);

export const SocialLinksList = styled(List)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s12};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s5};
  `,
);

export const TermsLink = styled(FooterLink)(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    color: ${theme.co.neutral60};
  `,
);

export const TermsLinksList = styled(List)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s10};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: ${theme.sz.s5};
  `,
);
